import { Lock } from "lucide-react";
import { Card } from "@/lib/ami";

const TEXT = {
  2: "Order Flow, Liquiditätszonen, Derivate-Divergenzen und Marktreaktionsdatenbank entstehen in Phase 2. Bis dahin zeigt AMI hier bewusst keine Werte.",
  3: "Prognosen, Strategien und Backtests entstehen in Phase 3 – mit statistischen Baselines, Out-of-Sample-Validierung und Prognosehistorie. Noch kein validiertes Modell.",
  4: "Stop-Loss-Modelle A–F und die unabhängige Risk & Execution Engine folgen in Phase 4. Die harten Limits sind bereits festgelegt (siehe Systemeinstellungen).",
  5: "Demo-Orders, Positionsüberwachung und Lernanalysen folgen in Phase 5 – erst nach validierten Modellen.",
  6: "Live-Trading ist serverseitig gesperrt und wird erst nach deiner gesonderten Freigabe in Phase 6 möglich.",
};

export default function AmiPlaceholder({ title, phase }) {
  return (
    <Card testid="ami-placeholder">
      <div className="flex items-start gap-4">
        <div className="h-10 w-10 shrink-0 rounded-full bg-primary/15 border border-primary/30 grid place-items-center">
          <Lock className="h-4 w-4 text-primary-foreground/80" strokeWidth={1.5} />
        </div>
        <div>
          <div className="overline mb-1">Phase {phase} · noch nicht aktiv</div>
          <h2 className="font-heading text-lg" data-testid="ami-placeholder-title">{title}</h2>
          <p className="mt-2 text-sm text-muted-foreground max-w-xl leading-relaxed">{TEXT[phase]}</p>
        </div>
      </div>
    </Card>
  );
}
